import Text from "@/components/common/Text"
import React from "react"
import styled from "styled-components"
import SingleNewsVariant from "@/components/downloadFiles/variants/SingleNewsVariant"

const FilesContainer = styled.div``

export default function FilesDescription({ desc, color, files }) {
	return (
		<div className="description">
			<Text tag="div" className="typo-borna typo-borna-11" color={color} dangerouslySetInnerHTML={desc} />
			<FilesContainer className="files">
				<SingleNewsVariant data={files} />
			</FilesContainer>
		</div>
	)
}
